import { timeStamp } from "console";
import { format } from "date-fns";


export function formaTimestampTo_DD_MM_YY(timestamp:number):string{
    const _date=new Date(timestamp)
    return format(_date,"dd/MM/y")
}
export function formaDateTo_DD_MM_YY(_date:Date):string{
    return format(_date,"dd/MM/y")
}